import {
  type ElementMetaRenderFeatures,
  type RenderElementContext,
} from '@blaze-shared/elements-domain';

import { type CanvasElement, type CanvasElementId } from '../canvas-element/canvas-element';
import { type SizeSettings } from '../canvas-element/props';
import {
  type SlotAlignment,
  type SlotHost,
  type SlotId,
  type SlotSizing,
} from '../canvas-element/slots';

export const BLAZE_ELEMENT_CLASS = 'blaze-element';
export const BLAZE_ELEMENT_HOST_CLASS = 'blaze-host';
export const BLAZE_SLOT_CLASS = 'blaze-slot';
/** Any target (element or slot) */
export const BLAZE_TARGET_CLASS = 'blaze-target';

/** Element / Slot invisibility class - do not use outside of core engine classes */
export const BLAZE_HIDDEN_CLASS = 'be-hidden';

/**
 * Element / Slot invisibility class used to partially hide element in editor.
 * Do not use outside of core engine classes!
 */
export const BLAZE_EDITOR_HIDDEN_CLASS = 'be-hidden-editor';

export const PAGE_ROOT_ID_ATTR = 'data-page-root-id';

export const ELEMENT_ID_ATTR = 'data-id';
export const ELEMENT_INDEX_ATTR = 'data-index';
export const ELEMENT_PARENT_ID_ATTR = 'data-parent-id';
export const ELEMENT_SLOT_ATTR = 'data-slot';
export const ELEMENT_SLOT_CONTAINER_ATTR = 'data-slot-container';
export const ELEMENT_REFERENCED_SLOT_ID_ATTR = 'data-referenced-slot-id';

export interface RendererNodeItem {
  index?: number;
  element: CanvasElement;
  slotNodes: SlotNodeData[];
  isSelected?: boolean;
  isOnPath?: boolean;
  elementContext?: RenderElementContext;
  features?: ElementMetaRenderFeatures;
  sizeOverride?: SizeSettings;
}

export interface SlotNodeData<Props extends object = object> {
  slotId: SlotId;
  elementId: CanvasElementId;
  isOnPath: boolean;
  isSelected: boolean;
  /** Is dynamic column (inside of container element) */
  isColumn: boolean;
  hosting?: SlotHost;
  sizing?: SlotSizing;
  alignment?: SlotAlignment;
  props?: Props;
}
